import { useQuery } from 'react-query';
import { useToastError } from 'lib/hooks/useToastError';
import { metricsKeys } from './metricsKeys';
import { REPORT_SCOPE } from '../reportsApi';
import { useReportData } from 'lib/const';
import { EXPRESS_API } from 'configs/api/expressApi';

export interface ReportParams {
  reportType: string;
  from: string;
  to: string;
  customer?: string;
  users?: string;
  retryCount?: number;
  reportScope?: REPORT_SCOPE;
  organizationId?: string | number;
  organizationRegionId?: string | number;
  allowDecimals?: boolean;
  timezoneOffset: number;
  reportId?: string;
}

const getReport = async (params: ReportParams, report: any): Promise<any> => {
  const {
    from,
    to,
    users,
    retryCount,
    customer,
    reportScope = REPORT_SCOPE.RESELLER,
    organizationId,
    organizationRegionId,
    timezoneOffset,
    reportId,
  } = params;

  return (
    await EXPRESS_API.get(`${report.url}`, {
      params: {
        from,
        to,
        users,
        retryCount,
        customer,
        timezoneOffset,
        reportScope,
        organizationId,
        organizationRegionId,
        reportId,
      },
    })
  ).data;
};

export const useQueryReport = (params: ReportParams) => {
  const { showError } = useToastError();
  const { reportData } = useReportData();
  let report = reportData[params.reportType];

  if (!report) {
    report = reportData.views;
  }

  return useQuery(
    metricsKeys.report(params, params.reportType),
    () => getReport(params, report),
    {
      onError: showError,
      refetchOnMount: true,
    }
  );
};
